import React from 'react'

function BigClose() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="129.795" height="129.795" viewBox="0 0 129.795 129.795">
      <g id="close" transform="translate(0.75 0.75)">
        <g id="Group_287" data-name="Group 287">
          <g id="Group_286" data-name="Group 286">
            <path id="Path_3150" data-name="Path 3150" d="M109.507,18.788a64.148,64.148,0,0,0-90.718,90.719,64.148,64.148,0,0,0,90.718-90.719Zm-5.315,85.4A56.63,56.63,0,0,1,24.1,24.1a56.63,56.63,0,1,1,80.087,80.087Z" transform="translate(0)" fill="#e2e2e2" stroke="#e2e2e2" stroke-width="1.5" />
          </g>
        </g>
        <g id="Group_289" data-name="Group 289" transform="translate(45.76 45.76)">
          <g id="Group_288" data-name="Group 288" transform="translate(-9 -11.433)">
            <path id="Path_3151" data-name="Path 3151" d="M195.87,190.6l-22.748-22.748L195.87,145.11a3.723,3.723,0,0,0-5.266-5.265l-22.747,22.747-22.748-22.748a3.723,3.723,0,0,0-5.266,5.266l22.748,22.748L139.843,190.6a3.723,3.723,0,0,0,5.266,5.266l22.748-22.748L190.6,195.871a3.723,3.723,0,0,0,5.266-5.266Z" transform="translate(-138.753 -138.753)" fill="#f37d27" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default BigClose